import { render } from "./ApicBaseLibrarySelect.vue?vue&type=template&id=79c24a5e"
import script from "./ApicBaseLibrarySelect.vue?vue&type=script&lang=js"
export * from "./ApicBaseLibrarySelect.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/citizenm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__